<template>
	<el-dialog title="查验详情" class="customDialog" :visible="show" width="660px" append-to-body @opened="handleOpened"
		:before-close="() => $emit('update:show', false)">
		<el-scrollbar class="dialog-scrollbar" v-show="verifyResult.length > 1">
			<ul class="left-tab">
				<li ref="isleft" class="is-left" style="height: 40px"></li>
				<li v-for="(item, index) in verifyResult" :key="index" :class="{ active: activeName === index }"
					@click="handleChoose(item.index,index)">
					<img :src="item.img" />
					<p :title="item.name">{{ item.name }}</p>
				</li>
			</ul>
		</el-scrollbar>
		<div class="modal_wrapper">
			<div class="cont">
				<div class="state">
					<span v-if="verifyInfo.type!='Sign'">
						<img src="@comm/images/document-conversion/electronic/success.png" v-if="verifyInfo.result == 0||(verifyInfo.result >='0X00000900'&&verifyInfo.result <= '0X000009FF')" />
						<img src="@comm/images/document-conversion/electronic/error.png" v-else />
					</span>
					<span v-else>
						<img src="@comm/images/document-conversion/electronic/qm_icon.png" v-if="verifyInfo.result == 0||(verifyInfo.result >='0X00000900'&&verifyInfo.result <= '0X000009FF')" />
						<img src="@comm/images/document-conversion/electronic/qm_icon_no.png" v-else />
					</span>

					<div class="info">
						<div class="info_title" v-if="verifyInfo.result == 0||(verifyInfo.result >='0X00000900'&&verifyInfo.result <= '0X000009FF')">{{ verifyInfo.type!='Sign'?"该签章有效！":"该签名有效！"}}
							<el-tooltip :content="verifyInfo.message" placement="bottom-start" v-if="verifyInfo.message"
								effect="light">
								<img src="@comm/images/document-conversion/warning_icon.png" class="warning_icon"/>
							</el-tooltip>
						</div>
						<div class="info_title" v-else>{{verifyInfo.type!='Sign'?"该签章无效！":"该签名无效！" }}
						</div>
						<div class="subtitle" v-if="verifyInfo.type!='Sign'">
							该签章受保护的部分<strong v-if="verifyInfo.result == 0||(verifyInfo.result >='0X00000900'&&verifyInfo.result <= '0X000009FF')">未被修改。</strong><strong v-else>有变更。</strong>
						</div>
						<div class="subtitle" v-else>
							<span v-if="verifyInfo.result == 0||(verifyInfo.result >='0X00000900'&&verifyInfo.result <= '0X000009FF')">该签名受保护的部分</span><span v-else>签名验证有误，无法解析该签章</span><strong v-if="verifyInfo.result == 0||(verifyInfo.result >='0X00000900'&&verifyInfo.result <= '0X000009FF')">未被修改</strong>。
						</div>
					</div>
				</div>
				<div class="signature">
					<div class="signature_title">{{verifyInfo.type=='Sign'?'签名信息':'签章信息'}}</div>
					<div class="info">
						<div class="list_item">
							<span class="label">{{verifyInfo.type=='Sign'?'签名人：':'签章人：'}}</span>
							<p>{{ verifyInfo.signature.people }}</p>
						</div>
						<div class="list_item">
							<span class="label">{{verifyInfo.type=='Sign'?'签名时间：':'签章时间：'}}</span>
							<p>{{ verifyInfo.signature.date }}</p>
						</div>
					</div>
				</div>
				<div class="seal" v-if="verifyInfo.type!='Sign'">
					<div class="seal_title">印章信息</div>
					<div class="info">
						<div class="list_item">
							<span class="label">印章名称：</span>
							<p>{{ verifyInfo.seal.people }}</p>
						</div>
						<div class="list_item">
							<span class="label">有效起止时间：</span>
							<p>{{ verifyInfo.seal.date }}</p>
						</div>
					</div>
				</div>
			</div>
			<div slot="footer" class="dialog-footer" style="text-align: right;">
				<el-button @click="closedBtn">&ensp;关闭&ensp;</el-button>
			</div>
		</div>
	</el-dialog>
</template>

<script>
export default {
	name: "CheckedSignatrue",
	props: {
		show: { type: Boolean, default: false },
		sealInfoList: { type: Array, default: () => [] },
		verifyResult: { type: Array, default: () => [] }
	},
	data() {
		return {
			key: "value",
			activeName: 0,
			verifyInfo: {
				result: true,
				type: '',
				message:'',
				signature: {
					people: "",
					date: "",
					img: ""
				},
				seal: {
					people: "",
					date: ""
				}
			}
		};
	},
	watch: {
		show(newValue, oldValue) {
			if (newValue) {
				const firstData = this.sealInfoList[0];
				const firstResult = this.verifyResult[0];
				this.verifyInfo = {
					result: firstResult.code,
					message:firstResult.message,
					type: firstData.type,
					signature: {
						people: firstData.signCert.subjectInfo.commonName,
						date: firstData ? firstData.timeInfo : null
					},
					seal: {
						people: firstData.sealName,
						date: `从${firstData.validStart} 到 ${firstData.validEnd}`
					}
				};
			}
		}
	},
	methods: {
		handleOpened() {
			this.activeName = 0;
			this.$refs.isleft.style = "transform: translateY(0px)";
		},
		handleChoose(tabIndex,index) {
			this.activeName = index;
			this.verifyInfo = {
				result: this.verifyResult[index].code,
				message:this.verifyResult[index].message,
				type: this.sealInfoList[tabIndex].type,
				signature: {
					people: this.sealInfoList[tabIndex].signCert.subjectInfo.commonName,
					date: this.sealInfoList[tabIndex].timeInfo,
					img: this.sealInfoList[tabIndex].sealImage.pictureData
				},
				seal: {
					people: this.sealInfoList[tabIndex].sealName,
					date: `从${this.sealInfoList[tabIndex].validStart} 到 ${this.sealInfoList[tabIndex].validEnd}`
				}
			};
			this.$refs.isleft.style = `transform: translateY(${tabIndex * 40}px);`;
		},
		closedBtn() {
			this.activeName = 0;
			this.$emit("update:show", false);
		}
	}
};
</script>

<style lang="scss" scoped>
.dialog-scrollbar {
	height: 440px;
	width: 138px;
	overflow-x: hidden;
	background: #f5f7fa;
}

.left-tab {
	overflow: hidden;
	width: 100%;
	height: auto;
	position: relative;

	li.is-left {
		position: absolute;
		top: 0;
		left: 0;
		width: 2px;
		height: 40px;
		background-color: #409eff;
		z-index: 1;
		transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
		list-style: none;
		padding: 0;
		margin: 0;
	}

	li {
		height: 40px;
		line-height: 40px;
		padding-left: 20px;
		display: flex;
		align-items: center;
		cursor: pointer;
		color: #8b97af;
		font-size: 14px;

		&:hover {
			p {
				color: #14a8f0;
			}
		}

		img {
			width: 24px;
			margin-right: 6px;
		}

		p {
			flex: 1;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			word-break: break-all;
		}
	}

	li.active {
		background-color: #fff;
		color: #14a8f0;
	}
}

.modal_wrapper {
	height: 440px;
	flex: 1;
	vertical-align: top;
	padding: 20px 30px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	font-family: "Microsoft YaHei";
	overflow-y: auto;

	.state {
		margin: 16px 0 24px 0;
		display: flex;
		justify-content: flex-start;

		img {
			width: 42px;
			height: 42px;
			&.warning_icon{
				width: 16px;
			height: 16px;
			}
		}

		.info {
			margin-left: 24px;

			.info_title {
				font-size: 20px;
				color: #36425a;
			}

			.subtitle {
				margin-top: 8px;
				font-size: 14px;
				color: #666;
			}
		}
	}

	.signature,
	.seal {

		.signature_title,
		.seal_title {
			color: rgba(79, 93, 121, 0.5);
			margin: 32px 0 22px 0;
		}

		.info {


			&>div {
				display: flex;
				justify-content: flex-start;
				margin-bottom: 16px;

				span {
					&:first-child {
						width: 114px;
						text-indent: 16px;
					}
				}

				p {
					flex: 1;
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/comm/components/document-conversion/electronicDec/components/SignatureDialog.vue